<template lang="html">
  <div class="legal-document-body flex flex-col gap-3">
    <template v-for="(block, index) in blocks" :key="index">
      <p v-if="block.type === 'p'">
        {{ block.text }}
      </p>

      <h2 v-else-if="block.type === 'h2'" class="mt-4 font-semibold first:mt-0">
        {{ block.text }}
      </h2>

      <h3 v-else-if="block.type === 'h3'" class="mt-2 font-medium">
        {{ block.text }}
      </h3>

      <ul v-else-if="block.type === 'ul'" class="list-disc space-y-1 pl-5">
        <li v-for="item in block.items" :key="item">
          {{ item }}
        </li>
      </ul>

      <div v-else-if="block.type === 'table'" class="overflow-x-auto">
        <table class="w-full min-w-[480px] border-collapse text-left">
          <thead>
            <tr>
              <th
                v-for="header in block.headers"
                :key="header"
                class="border border-default px-3 py-2 font-semibold"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, rowIndex) in block.rows" :key="rowIndex">
              <td
                v-for="(cell, cellIndex) in row"
                :key="`${rowIndex}-${cellIndex}`"
                class="border border-default px-3 py-2 align-top whitespace-pre-line"
              >
                {{ cell }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { LegalDocumentBlock } from '#Info/types/legalDocument'

defineProps<{
  blocks: LegalDocumentBlock[]
}>()
</script>
